import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import Climate from '@crehana/compass.icons.logos/Climate';
import Performance from '@crehana/compass.icons.logos/Performance';
import Recognition from '@crehana/compass.icons.logos/Recognition';
import ActivityCheck from '@crehana/compass.icons.outline/ActivityCheck';
import AppsComments from '@crehana/compass.icons.outline/AppsComments';
import Badge from '@crehana/compass.icons.outline/Badge';
import Building from '@crehana/compass.icons.outline/Building';
import Departments from '@crehana/compass.icons.outline/Departments';
import File from '@crehana/compass.icons.outline/File';
import Flag from '@crehana/compass.icons.outline/Flag';
import Gift from '@crehana/compass.icons.outline/Gift';
import Home from '@crehana/compass.icons.outline/Home';
import OKRs from '@crehana/compass.icons.outline/OKRs';
import People from '@crehana/compass.icons.outline/People';
import Power from '@crehana/compass.icons.outline/Power';
import Presentation from '@crehana/compass.icons.outline/Presentation';
import Recruitment from '@crehana/compass.icons.outline/Recruitment';
import Report from '@crehana/compass.icons.outline/Report';
import Stats from '@crehana/compass.icons.outline/Stats';
import SuccessionPlan from '@crehana/compass.icons.outline/SuccessionPlan';
import TrendingUp from '@crehana/compass.icons.outline/TrendingUp';
import Learning from '@crehana/icons/logos/Elearning';
import { isProduction } from "../../../constants";
import { addProductsLabelSeparatorSubtitle } from "../../utils";
import HelperTooltip from "../../SidebarMenu/components/HelperTooltip";
import useCollaboratorTranslations from "./useCollaboratorTranslations";
import { jsx as _jsx } from "react/jsx-runtime";
var FRONTEND_NESTED_LINKS_DATA = {
  OKRS: {
    label: 'Objetivos'
  },
  OKRS_ALIGNMENT: {
    label: 'Alineación'
  },
  OKRS_CONFIGURATION: {
    label: 'Configuracion'
  }
};
var PRODUCTION_BASE_URL = 'https://crehana.acsendo.com/rest/saml3/login?next=https://crehana.acsendo.com/company/home';
var QA_BASE_URL = 'https://pruebas.acsendo.com/rest/saml3/login?next=https://pruebas.acsendo.com/company/home';
var BASE_URL = isProduction ? PRODUCTION_BASE_URL : QA_BASE_URL;
var URLS = {
  analytics: /*#__PURE__*/"".concat(BASE_URL, "?source_page=side%20bar%26loadModule=STADISTICS_ANALYTICS"),
  results: /*#__PURE__*/"".concat(BASE_URL, "?source_page=side%20bar%26loadModule=COLLABORATOR_RESULTS"),
  company: /*#__PURE__*/"".concat(BASE_URL, "?source_page=side%20bar%26loadModule=COMPANY"),
  recognitions: /*#__PURE__*/"".concat(BASE_URL, "?source_page=side%20bar%26loadModule=RECOGNITION_ENGAGEMENT"),
  performance: /*#__PURE__*/"".concat(BASE_URL, "?source_page=side%20bar%26loadModule=PERFORMANCE"),
  workingEnvironment: /*#__PURE__*/"".concat(BASE_URL, "?source_page=side%20bar%26loadModule=CLIMATE")
};
// We're using a const instead of Enum to do not depend on typescript on this
export var ModuleCode = {
  Products: 'PRODUCTS',
  Analytics: 'ANALYTICS',
  Company: 'COMPANY',
  Climate: 'CLIMATE_ENGAGEMENT',
  ELearning: 'LEARNING',
  Performance: 'PERFORMANCE',
  Recognition: 'RECOGNITION',
  MyTeam: 'MY_TEAM'
};
export var useUtils = function useUtils(_ref) {
  var organizationSlug = _ref.organizationSlug;
  var _useCollaboratorTrans = useCollaboratorTranslations(),
    t = _useCollaboratorTrans.t;
  var shouldRenderNewMyTeamLinks = new URLSearchParams(window.location.search).get('shouldRenderNewMyTeamLinks') === 'true';
  var getProductsLinks = function getProductsLinks(_ref2) {
    var _ref2$talentModules = _ref2.talentModules,
      talentModules = _ref2$talentModules === void 0 ? [] : _ref2$talentModules,
      isLearningModuleActive = _ref2.isLearningModuleActive;
    var frontendModules = [
    // Home
    {
      code: 'HOME',
      label: t('MODULE_HOME'),
      icon: Home,
      url: "/org/".concat(organizationSlug, "/home"),
      decoratedIcon: false,
      arrowDefault: false,
      tooltip: t('MODULE_HOME')
    }].concat(_toConsumableArray(shouldRenderNewMyTeamLinks ? [
    // My team
    {
      code: ModuleCode.MyTeam,
      label: t('MODULE_MY_TEAM'),
      url: ModuleCode.MyTeam,
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('TOOLTIP_TITLE_MODULE_MY_TEAM'),
        description: t('TOOLTIP_DESCRIPTION_MODULE_MY_TEAM')
      }),
      icon: People,
      decoratedIcon: false
    },
    // My results
    {
      code: 'COLLABORATOR_RESULTS',
      label: t('MODULE_MY_RESULTS'),
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('TOOLTIP_TITLE_MY_RESULTS'),
        description: t('TOOLTIP_DESCRIPTION_MY_RESULTS')
      }),
      arrowDefault: false,
      icon: Stats,
      decoratedIcon: false
    }] : [
    // Collaborator results
    {
      code: 'COLLABORATOR_RESULTS',
      label: t('MODULE_MY_RESULTS'),
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('TOOLTIP_MY_RESULTS_TITLE'),
        description: t('TOOLTIP_MY_RESULTS_DESCRIPTION')
      }),
      arrowDefault: false,
      icon: Presentation,
      decoratedIcon: false
    },
    // Analytics
    {
      code: 'ANALYTICS',
      label: t('MODULE_ANALYTICS'),
      url: ModuleCode.Analytics,
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('MODULE_ANALYTICS'),
        description: t('TOOLTIP_ANALYTICS_DESCRIPTION')
      }),
      icon: Stats,
      decoratedIcon: false
    }]), [
    // Company
    {
      code: 'COMPANY',
      label: t('MODULE_COMPANY'),
      icon: Building,
      url: ModuleCode.Company,
      arrowDefault: true,
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('MODULE_COMPANY'),
        description: t('TOOLTIP_COMPANY_DESCRIPTION')
      })
    },
    // Recognition
    {
      code: 'RECOGNITION',
      label: t('MODULE_RECOGNITION'),
      icon: Recognition,
      url: ModuleCode.Recognition,
      decoratedIcon: true,
      isProductModule: true,
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('MODULE_RECOGNITION'),
        description: t('TOOLTIP_RECOGNITION_DESCRIPTION')
      })
    },
    // Performance
    {
      code: 'PERFORMANCE',
      label: t('MODULE_PERFORMANCE'),
      icon: Performance,
      decoratedIcon: true,
      url: ModuleCode.Performance,
      isProductModule: true,
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('MODULE_PERFORMANCE'),
        description: t('TOOLTIP_PERFORMANCE_DESCRIPTION')
      })
    },
    // Climate
    {
      code: 'CLIMATE_ENGAGEMENT',
      label: t('MODULE_CLIMATE'),
      icon: Climate,
      decoratedIcon: true,
      url: ModuleCode.Climate,
      isProductModule: true,
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('MODULE_CLIMATE'),
        description: t('TOOLTIP_CLIMATE_DESCRIPTION')
      })
    }, {
      code: 'E-LEARNING',
      label: t('MODULE_LEARNING'),
      icon: Learning,
      url: ModuleCode.ELearning,
      decoratedIcon: true,
      arrowDefault: true,
      isProductModule: true,
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('MODULE_LEARNING'),
        description: t('TOOLTIP_LEARNING_DESCRIPTION')
      })
    }]) // Merge with backend data
    .map(function (frontendModule) {
      var _frontendModule$arrow, _backendTalentModule$;
      var backendTalentModule = talentModules.find(function (talentModule) {
        return talentModule.code === frontendModule.code;
      });

      // The HOME module is the only module that we shouldn't override with backend data
      if (frontendModule.code === 'HOME') {
        return frontendModule;
      }
      return _objectSpread(_objectSpread({}, frontendModule), {}, {
        label: (backendTalentModule === null || backendTalentModule === void 0 ? void 0 : backendTalentModule.label) || frontendModule.label,
        arrowDefault: (_frontendModule$arrow = frontendModule.arrowDefault) !== null && _frontendModule$arrow !== void 0 ? _frontendModule$arrow : !(backendTalentModule !== null && backendTalentModule !== void 0 && backendTalentModule.url),
        // We only override the URL if the backend provides it,
        url: (_backendTalentModule$ = backendTalentModule === null || backendTalentModule === void 0 ? void 0 : backendTalentModule.url) !== null && _backendTalentModule$ !== void 0 ? _backendTalentModule$ : frontendModule.url
      });
    });
    var backendModulesCodes = talentModules.map(function (module) {
      return module.code;
    });
    if (isLearningModuleActive) {
      backendModulesCodes.push('E-LEARNING');
    }
    if (shouldRenderNewMyTeamLinks) {
      backendModulesCodes.push('MODULE_MY_TEAM', 'MODULE_MY_RESULTS');
    }
    var productsLinks = frontendModules.filter(function (frontendModule) {
      return backendModulesCodes.includes(frontendModule.code);
    });
    var subtitle = t('MODULE_PRODUCTS_SUBTITLE');
    return addProductsLabelSeparatorSubtitle(productsLinks, subtitle);
  };
  var getSubmodules = function getSubmodules(_ref3) {
    var _talentModules$find$s, _talentModules$find7;
    var talentModules = _ref3.talentModules,
      moduleCode = _ref3.moduleCode;
    var data = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ModuleCode.MyTeam, [
    // Leader dashbaord
    {
      code: 'ACTIVE_PROCESS',
      label: t('SUBMODULE_ACTIVE_PROCESSES'),
      icon: Power,
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('SUBMODULE_ACTIVE_PROCESSES'),
        description: t('SUBMODULE_TOOLTIP_ACTIVE_PROCESSES_DESCRIPTION')
      })
    },
    // Team results
    {
      code: 'LEADER_RESULTS',
      label: t('SUBMODULE_MY_TEAM_RESULTS'),
      icon: Presentation,
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('SUBMODULE_MY_TEAM_RESULTS'),
        description: t('TOOLTIP_DESCRIPTION_SUBMODULE_MY_TEAM_RESULTS')
      })
    }].map(function (item) {
      var _talentModules$find, _talentModule$url;
      var talentModule = (_talentModules$find = talentModules.find(function (_module) {
        return _module.code === ModuleCode.MyTeam;
      })) === null || _talentModules$find === void 0 ? void 0 : _talentModules$find.submodules.find(function (subLevelItem) {
        return subLevelItem.code === item.code;
      });
      return _objectSpread(_objectSpread({}, item), {}, {
        label: (talentModule === null || talentModule === void 0 ? void 0 : talentModule.label) || item.label,
        // Only replace the URL if the backend provides it
        url: (_talentModule$url = talentModule === null || talentModule === void 0 ? void 0 : talentModule.url) !== null && _talentModule$url !== void 0 ? _talentModule$url : ''
      });
    })), "ANALYTICS", [{
      code: 'COLLABORATOR_RESULTS',
      label: t('SUBMODULE_RESULTS_TITLE'),
      icon: Presentation,
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('SUBMODULE_RESULTS_TITLE'),
        description: t('SUBMODULE_TOOLTIP_MY_RESULTS_DESCRIPTION')
      })
    }, {
      code: 'LEADER_RESULTS',
      label: t('SUBMODULE_LEADER_RESULTS_TITLE'),
      icon: Departments,
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('SUBMODULE_LEADER_RESULTS_TITLE'),
        description: t('SUBMODULE_TOOLTIP_LEADER_RESULTS_DESCRIPTION')
      })
    }].map(function (item) {
      var _talentModules$find2, _talentModule$url2;
      var talentModule = (_talentModules$find2 = talentModules.find(function (_module) {
        return _module.code === 'ANALYTICS';
      })) === null || _talentModules$find2 === void 0 ? void 0 : _talentModules$find2.submodules.find(function (subLevelItem) {
        return subLevelItem.code === item.code;
      });
      return _objectSpread(_objectSpread({}, item), {}, {
        label: (talentModule === null || talentModule === void 0 ? void 0 : talentModule.label) || item.label,
        // Only replace the URL if the backend provides it
        url: (_talentModule$url2 = talentModule === null || talentModule === void 0 ? void 0 : talentModule.url) !== null && _talentModule$url2 !== void 0 ? _talentModule$url2 : ''
      });
    })), "COMPANY", [{
      code: 'COMPANY_DIRECTORY',
      label: t('SUBMODULE_DIRECTORY_TITLE'),
      icon: Recruitment,
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('SUBMODULE_DIRECTORY_TITLE'),
        description: t('SUBMODULE_TOOLTIP_DIRECTORY_DESCRIPTION')
      })
    }, {
      code: 'COMPANYCHART',
      label: t('SUBMODULE_COMPANY_CHART_TITLE'),
      icon: Departments,
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('SUBMODULE_COMPANY_CHART_TITLE'),
        description: t('SUBMODULE_COMPANY_CHART_DESCRIPTION')
      })
    }].map(function (item) {
      var _talentModules$find3, _talentModule$url3;
      var talentModule = (_talentModules$find3 = talentModules.find(function (_module) {
        return _module.code === 'COMPANY';
      })) === null || _talentModules$find3 === void 0 ? void 0 : _talentModules$find3.submodules.find(function (subLevelItem) {
        return subLevelItem.code === item.code;
      });
      return _objectSpread(_objectSpread({}, item), {}, {
        label: (talentModule === null || talentModule === void 0 ? void 0 : talentModule.label) || item.label,
        // Only replace the URL if the backend provides it
        url: (_talentModule$url3 = talentModule === null || talentModule === void 0 ? void 0 : talentModule.url) !== null && _talentModule$url3 !== void 0 ? _talentModule$url3 : ''
      });
    })), "RECOGNITION", [{
      code: 'RECOGNITION',
      label: t('SUBMODULE_RECOGNITION_TITLE'),
      icon: Badge,
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('SUBMODULE_RECOGNITION_TITLE'),
        description: t('SUBMODULE_TOOLTIP_RECOGNITION_DESCRIPTION')
      })
    }, {
      code: 'RECOGNITION_REDEMPTION',
      label: t('SUBMODULE_RECOGNITION_REDEMPTION_TITLE'),
      icon: Gift,
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('SUBMODULE_RECOGNITION_REDEMPTION_TITLE'),
        description: t('SUBMODULE_TOOLTIP_RECOGNITION_REDEMPTION_DESCRIPTION')
      })
    }].map(function (item) {
      var _talentModules$find4, _talentModule$url4;
      var talentModule = (_talentModules$find4 = talentModules.find(function (_module) {
        return _module.code === 'RECOGNITION';
      })) === null || _talentModules$find4 === void 0 ? void 0 : _talentModules$find4.submodules.find(function (subLevelItem) {
        return subLevelItem.code === item.code;
      });
      return _objectSpread(_objectSpread({}, item), {}, {
        label: (talentModule === null || talentModule === void 0 ? void 0 : talentModule.label) || item.label,
        // Only replace the URL if the backend provides it
        url: (_talentModule$url4 = talentModule === null || talentModule === void 0 ? void 0 : talentModule.url) !== null && _talentModule$url4 !== void 0 ? _talentModule$url4 : ''
      });
    })), "PERFORMANCE", [{
      code: 'OKRS_PERFORMANCE',
      label: t('SUBMODULE_OKRS_PERFORMNACE_TITLE'),
      icon: OKRs,
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('SUBMODULE_OKRS_PERFORMNACE_TITLE'),
        description: t('SUBMODULE_TOOLTIP_OKRS_PERFORMANCE_DESCRIPTION')
      })
    }, {
      code: 'GOALS',
      label: t('SUBMODULE_GOALS_TITLE'),
      icon: Flag,
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('SUBMODULE_GOALS_TITLE'),
        description: t('SUBMODULE_TOOLTIP_GOALS_DESCRIPTION')
      })
    }, {
      code: 'COMPETENCES',
      label: t('SUBMODULE_COMPETENCES_TITLE'),
      icon: Report,
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('SUBMODULE_COMPETENCES_TITLE'),
        description: t('SUBMODULE_TOOTLTIP_COMPETENCES_DESCRIPTION')
      })
    }, {
      code: 'FEEDBACK',
      label: t('SUBMODULE_FEEDBACK_TITLE'),
      icon: AppsComments,
      url: URLS.performance,
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('SUBMODULE_FEEDBACK_TITLE'),
        description: t('SUBMODULE_TOOLTIP_FEEDBACK_DESCRIPTION')
      })
    }, {
      code: 'PID',
      label: t('SUBMODULE_PID_TITLE'),
      icon: TrendingUp,
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('SUBMODULE_PID_TITLE'),
        description: t('SUBMODULE_TOOLTIP_PID_DESCRIPTION')
      })
    }, {
      code: 'SUCCESSION_PLAN',
      label: t('SUBMODULE_SUCESSION_PLAN_TITLE'),
      icon: SuccessionPlan,
      url: URLS.performance,
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('SUBMODULE_SUCESSION_PLAN_TITLE'),
        description: t('SUBMODULE_TOOLTIP_SUCESSION_PLAN_DESCRIPTION')
      })
    }].map(function (item) {
      var _talentModules$find5, _talentModule$url5;
      var talentModule = (_talentModules$find5 = talentModules.find(function (_module) {
        return _module.code === 'PERFORMANCE';
      })) === null || _talentModules$find5 === void 0 ? void 0 : _talentModules$find5.submodules.find(function (subLevelItem) {
        return subLevelItem.code === item.code;
      });

      // Only replace the URL if the backend provides it
      return _objectSpread(_objectSpread({}, item), {}, {
        label: (talentModule === null || talentModule === void 0 ? void 0 : talentModule.label) || item.label,
        url: (_talentModule$url5 = talentModule === null || talentModule === void 0 ? void 0 : talentModule.url) !== null && _talentModule$url5 !== void 0 ? _talentModule$url5 : '',
        nested: talentModule !== null && talentModule !== void 0 && talentModule.url ? [] : talentModule === null || talentModule === void 0 ? void 0 : talentModule.submodules.map(
        // Format nested link
        function (backendNestedLink) {
          var _FRONTEND_NESTED_LINK;
          return {
            code: backendNestedLink.code,
            label:
            // @ts-expect-error validate later
            ((_FRONTEND_NESTED_LINK = FRONTEND_NESTED_LINKS_DATA[backendNestedLink.code]) === null || _FRONTEND_NESTED_LINK === void 0 ? void 0 : _FRONTEND_NESTED_LINK.label) || backendNestedLink.code,
            url: backendNestedLink.url
          };
        })
      });
    })), "CLIMATE_ENGAGEMENT", [{
      code: 'CLIMATE',
      label: t('SUBMODULE_CLIMATE_EVALUATION_TITLE'),
      icon: ActivityCheck,
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('SUBMODULE_CLIMATE_EVALUATION_TITLE'),
        description: t('SUBMODULE_TOOLTIP_CLIMATE_EVALUATION_DESCRIPTION')
      })
    }, {
      code: 'SURVEY',
      label: t('SUBMODULE_SURVEY_TITLE'),
      icon: File,
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('SUBMODULE_SURVEY_TITLE'),
        description: t('SUBMODULE_TOOLTIP_SURVEY_DESCRIPTION')
      })
    }].map(function (item) {
      var _talentModules$find6, _talentModule$url6;
      var talentModule = (_talentModules$find6 = talentModules.find(function (_module) {
        return _module.code === 'CLIMATE_ENGAGEMENT';
      })) === null || _talentModules$find6 === void 0 ? void 0 : _talentModules$find6.submodules.find(function (subLevelItem) {
        return subLevelItem.code === item.code;
      });

      // Only replace the URL if the backend provides it
      return _objectSpread(_objectSpread({}, item), {}, {
        label: (talentModule === null || talentModule === void 0 ? void 0 : talentModule.label) || item.label,
        url: (_talentModule$url6 = talentModule === null || talentModule === void 0 ? void 0 : talentModule.url) !== null && _talentModule$url6 !== void 0 ? _talentModule$url6 : ''
      });
    }));
    var submodulesCodes = ((_talentModules$find$s = (_talentModules$find7 = talentModules.find(function (_module) {
      return _module.code === moduleCode;
    })) === null || _talentModules$find7 === void 0 ? void 0 : _talentModules$find7.submodules) !== null && _talentModules$find$s !== void 0 ? _talentModules$find$s : []).map(function (_el) {
      return _el.code;
    });

    // This format is necessary to match the structure of the sidebar
    return _toConsumableArray(data[moduleCode]

    // @ts-expect-error TODO pending to type
    .filter(function (el) {
      return (
        // Filter only the necessary submodules from the whole data
        submodulesCodes.includes(el.code)
      );
    })
    // @ts-expect-error TODO pending to type
    .map(function (el) {
      return _objectSpread({}, el);
    }));
  };
  return {
    getProductsLinks: getProductsLinks,
    getSubmodules: getSubmodules
  };
};